import { Col, Row, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { IoDuplicateOutline } from "react-icons/io5";
import { MdOpenInNew } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";

function CanvasList({ data, duplicate, duplicating, count, setValues, skip }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const CANVASES = t("CANVASES", { returnObjects: true });

  const columns = [
    {
      title: CANVASES.NAME,
      dataIndex: "name",
    },
    {
      title: CANVASES.STATUSES,
      dataIndex: "processStatuses",
      render: (processStatuses) => (
        <div className="tag-ellipsis">
          {processStatuses?.map((processStatus) => (
            <Tag key={processStatus.id}>{processStatus.name}</Tag>
          ))}
        </div>
      ),
    },
    {
      title: CANVASES.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id, record) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col>
            <button
              type="button"
              className="canvas-list__action"
              disabled={duplicating || !duplicate}
              aria-label={CANVASES.DUPLICATE}
              title={CANVASES.DUPLICATE}
              onClick={() => {
                if (duplicating || !duplicate) return;
                duplicate(id, `${record.name}${CANVASES.COPY_SUFFIX}`);
              }}
            >
              <IoDuplicateOutline size={24} color={COLORS.C_SUCCESS} />
            </button>
          </Col>
          <Col>
            <button
              type="button"
              className="canvas-list__action"
              aria-label={CANVASES.OPEN}
              title={CANVASES.OPEN}
              onClick={() =>
                navigate(`${SCREENS.PRIVATE.ADMIN.CANVASES.path}/${id}`)
              }
            >
              <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
            </button>
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default CanvasList;
